import { render, staticRenderFns } from "./MoveBuilding.vue?vue&type=template&id=b95662f0&scoped=true"
import script from "./MoveBuilding.vue?vue&type=script&lang=js"
export * from "./MoveBuilding.vue?vue&type=script&lang=js"
import style0 from "./MoveBuilding.vue?vue&type=style&index=0&id=b95662f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95662f0",
  null
  
)

export default component.exports